import React, { useState } from 'react';
import { useQuery } from 'react-query';
import api from '../services/api';
import { FiChevronDown, FiChevronRight, FiSearch } from 'react-icons/fi';

const limit = 25;

const Parents = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [expanded, setExpanded] = useState({}); // { [eleveId]: bool }

  // Récupère les élèves avec leurs parents
  // eslint-disable-next-line no-unused-vars
  const { data, isLoading, refetch } = useQuery(
    ['eleves-with-parents', page, search],
    () =>
      api
        .get(`/eleves/with-parents?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`)
        .then((res) => res.data),
    { keepPreviousData: true }
  );

  // Pagination frontale (locale)
  const parentsArray = Array.isArray(data?.data) ? data.data : [];
  const total = parentsArray.length;
  const totalPages = Math.ceil(total / limit) || 1;
  const paginatedParents = parentsArray.slice((page - 1) * limit, page * limit);

  // Gestion de l'accordion
  const toggleExpand = (eleveId) => {
    setExpanded((prev) => ({ ...prev, [eleveId]: !prev[eleveId] }));
  };

  // Recherche
  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  console.log('DEBUG Parents.js', {data, total, totalPages, page, limit});
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Parents par élève</h1>
      </div>
      {/* Barre de recherche */}
      <div className="bg-white p-4 rounded-lg shadow mb-6">
        <div className="relative">
          <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Rechercher élève ou parent..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
            value={search}
            onChange={handleSearch}
          />
        </div>
      </div>
      <div className="bg-white shadow rounded-lg overflow-hidden">
        {isLoading ? (
          <div className="p-8 text-center">Chargement...</div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Élève</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Matricule</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Sexe</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date naissance</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Téléphone</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Parents</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {parentsArray.length === 0 ? (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                    Aucun élève trouvé
                  </td>
                </tr>
              ) : (
                paginatedParents.map((eleve) => (
                  <React.Fragment key={eleve.id}>
                    <tr className="hover:bg-gray-50 cursor-pointer" onClick={() => toggleExpand(eleve.id)}>
                      <td className="px-6 py-4 flex items-center">
                        {expanded[eleve.id] ? (
                          <FiChevronDown className="mr-2 text-primary-600" />
                        ) : (
                          <FiChevronRight className="mr-2 text-primary-600" />
                        )}
                        <span>{eleve.nom} {eleve.prenom}</span>
                      </td>
                      <td className="px-6 py-4">{eleve.matricule}</td>
                      <td className="px-6 py-4">{eleve.sexe}</td>
                      <td className="px-6 py-4">{eleve.date_naissance}</td>
                      <td className="px-6 py-4">{eleve.telephone}</td>
                      <td className="px-6 py-4">{eleve.parents?.length || 0}</td>
                    </tr>
                    {expanded[eleve.id] && (
                      <tr>
                        <td colSpan="6" className="bg-gray-50 px-8 py-4">
                          {eleve.parents?.length === 0 ? (
                            <div className="text-gray-500">Aucun parent associé</div>
                          ) : (
                            <table className="min-w-full divide-y divide-gray-200">
                              <thead>
                                <tr>
                                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Nom</th>
                                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Prénom</th>
                                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Téléphone</th>
                                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                                </tr>
                              </thead>
                              <tbody>
                                {eleve.parents.map((parent) => (
                                  <tr key={parent.id}>
                                    <td className="px-4 py-2">{parent.nom}</td>
                                    <td className="px-4 py-2">{parent.prenom}</td>
                                    <td className="px-4 py-2">{parent.type_parente}</td>
                                    <td className="px-4 py-2">{parent.telmob1 || parent.telmob2}</td>
                                    <td className="px-4 py-2">{parent.email}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
      {/* Pagination locale harmonisée */}
      {!isLoading && totalPages > 1 && (
        <div className="flex justify-center items-center gap-1 mt-4 flex-wrap pb-4">
          <button onClick={() => setPage(1)} disabled={page === 1} className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-sm">Premier</button>
          <button onClick={() => setPage(page - 1)} disabled={page === 1} className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-sm">Précédent</button>
          {(() => {
            const pages = [];
            if (totalPages <= 10) {
              for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
              }
            } else {
              // 1 à 5, ..., totalPages-4 à totalPages
              for (let i = 1; i <= 5; i++) pages.push(i);
              if (page > 7 && page < totalPages - 6) {
                pages.push('...');
                for (let i = page - 1; i <= page + 1; i++) pages.push(i);
                pages.push('...');
              } else {
                pages.push('...');
              }
              for (let i = totalPages - 4; i <= totalPages; i++) {
                if (i > 5) pages.push(i);
              }
            }
            // Nettoyage et affichage
            return [...new Set(pages)].map((p, idx) =>
              p === '...'
                ? <span key={"ellipsis-" + idx} className="mx-0.5 px-2">...</span>
                : <button
                    key={p}
                    className={`px-2 py-1 rounded mx-0.5 text-sm ${p === page ? 'bg-primary-600 text-white' : 'bg-gray-100 hover:bg-primary-100 text-gray-700'}`}
                    onClick={() => setPage(p)}
                    disabled={p === page}
                  >{p}</button>
            );
          })()}
          <button onClick={() => setPage(page + 1)} disabled={page === totalPages} className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-sm">Suivant</button>
          <button onClick={() => setPage(totalPages)} disabled={page === totalPages} className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 text-sm">Dernier</button>
        </div>
      )}
    </div>
  );
};

export default Parents;
